if (typeof complementaryProductsComponent === 'undefined')
{
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const url = this.dataset.url;
            this.buildProducts(url);
        }

        static BRAND_PATTERNS = {
            'Apple':   /iphone|ipad|airpods|macbook|lightning|magsafe|apple\s+usb|apple\s+charger|apple\s+cable/i,
            'Samsung': /samsung|galaxy\b|note\s*\d/i,
            'Xiaomi':  /xiaomi|redmi|poco|mi\s+(?:9|10|11|12|13|note|max)/i,
            'Huawei':  /huawei|honor|mate\s*\d|p\d\d?\s*(pro|lite)?/i,
            'Google':  /pixel\b|google\s+phone/i,
            'OnePlus': /oneplus|1\+\s*\d/i,
            'Sony':    /xperia|sony\s+phone/i,
            'Nokia':   /nokia\b/i,
            'LG':      /lg\s+(g|v|k|q)\d/i,
        };

        detectBrand(text) {
            for (const [brand, re] of Object.entries(ComplementaryProductsComponent.BRAND_PATTERNS)) {
                if (re.test(text)) return brand;
            }
            return null;
        }

        extractModelTokens(modelTagsRaw) {
            if (!modelTagsRaw) return [];
            return modelTagsRaw.split('|')
                .filter(Boolean)
                .map(t => t.replace(/^mudel:\s*/i, '').trim().toLowerCase())
                .filter(t => t.length > 0);
        }

        buildProducts(url) {
            const sourceBrand = (this.dataset.sourceBrand || '').trim();
            const sourceTitle = (this.dataset.sourceTitle || '').trim().toLowerCase();
            const sourceModelTokens = this.extractModelTokens(this.dataset.sourceModelTags || '');
            const sourceHandle = (this.dataset.sourceHandle || '').trim();

            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();

                const html = document.createElement('div');
                text = text.replaceAll('variant-selects', 'div').replaceAll('variant-radios', 'div').replaceAll('product-tab', 'div').replaceAll('compare-color', 'div').replaceAll('breadcrumb-component', 'div');
                html.innerHTML = text;

                const recommendations = html.querySelector('[data-complementary-product]');
                if (!recommendations || !recommendations.innerHTML.trim().length) {
                    return;
                }

                // BRAND-AWARE FILTER: score candidates, drop mismatched brands
                const cards = Array.from(recommendations.querySelectorAll('.product'));
                const scored = [];

                cards.forEach(card => {
                    const titleEl = card.querySelector('.card-title, .product-card-title, .productView-title, .productitem-title, .product-name, .card-information__text');
                    const linkEl = card.querySelector('a[href*="/products/"]');
                    const cardTitle = (titleEl?.textContent || linkEl?.textContent || '').trim();
                    const cardHref = linkEl?.getAttribute('href') || '';
                    const cardText = (cardTitle + ' ' + cardHref).toLowerCase();
                    const candidateBrand = this.detectBrand(cardText);

                    if (sourceHandle && cardHref.includes('/products/' + sourceHandle)) {
                        return;
                    }

                    let priority = 3;
                    let keep = true;

                    if (sourceModelTokens.length > 0) {
                        for (const tok of sourceModelTokens) {
                            if (cardText.includes(tok)) {
                                priority = 1;
                                break;
                            }
                        }
                    }

                    if (priority > 2 && sourceBrand && candidateBrand === sourceBrand) {
                        priority = 2;
                    }

                    if (priority > 2 && candidateBrand && sourceBrand && candidateBrand !== sourceBrand) {
                        keep = false;
                    }

                    if (keep) scored.push({card, priority});
                });

                scored.sort((a, b) => a.priority - b.priority);

                const carousel = recommendations.querySelector('.products-carousel');
                if (carousel && scored.length > 0) {
                    const firstCard = scored[0].card;
                    const cardWrapper = firstCard.parentElement;
                    const wrapperTemplate = cardWrapper?.cloneNode(false);

                    carousel.innerHTML = '';
                    scored.forEach(({card}) => {
                        if (wrapperTemplate) {
                            const wrap = wrapperTemplate.cloneNode(false);
                            wrap.appendChild(card);
                            carousel.appendChild(wrap);
                        } else {
                            carousel.appendChild(card);
                        }
                    });
                }

                if (scored.length === 0) {
                    this.style.display = 'none';
                    return;
                }

                this.innerHTML = recommendations.innerHTML;

                if (window.sharedFunctions && window.sharedFunctions.checkNeedToConvertCurrency && window.sharedFunctions.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }

                const productCarousel = this.querySelector('.products-carousel');
                this.initializeSlider(productCarousel);
            };

            fetchProducts(url);
        }

        initializeSlider(productCarousel = null) {
            if (productCarousel) {
                const itemArrows = productCarousel.dataset.itemArrows === 'true';
                const itemDots = productCarousel.dataset.itemDots === 'true';
                const itemRows = parseInt(productCarousel.dataset.itemRows);
                const itemToShow = parseInt(productCarousel.dataset.itemToShow);
                const complementaryStyle = this.classList.contains('style-1') ? true : false;

                $(productCarousel).on('init', () => {
                    this.calculateCard06Padding();
                });

                if(!productCarousel.classList.contains('slick-slider')) {
                    $(productCarousel).slick({
                        dots: itemDots,
                        arrows: itemArrows,
                        slidesToShow: complementaryStyle ? itemToShow : 1,
                        rows: !complementaryStyle ? itemRows : 1,
                        slidesToScroll: 1,
                        slidesPerRow: 1,
                        infinite: true,
                        rtl: window.rtl_slick,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        responsive: [
                            { breakpoint: 1025, settings: { slidesToShow: complementaryStyle ? 2 : 1 } },
                            { breakpoint: 992,  settings: { slidesToShow: complementaryStyle ? 2 : 1 } },
                            { breakpoint: 768,  settings: { slidesToShow: complementaryStyle ? 2 : 1 } },
                            { breakpoint: 321,  settings: { slidesToShow: 1 } }
                        ]
                    });
                }
            }
        }

        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;
            const cardAction = this.querySelector('.product .card-action');
            const slickList = this.querySelector('.slick-list');
            if (cardAction && slickList) {
                slickList.style.paddingBottom = cardAction.scrollHeight + 'px';
            }
        }
    }

    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    });

    var complementaryProductsComponent = ComplementaryProductsComponent;
}
